<script setup>
import { ref } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
const route = useRoute();
const api_base_url = import.meta.env.VITE_API_BASE_URL;

const approvalUrl = ref(null);
const errorMessage = ref(null);
const checkoutToken = ref(route.params.token);
const loading = ref(false);


async function resumeCheckout(token) {
  errorMessage.value = null;
  if (!token) {
    errorMessage.value = "No checkout token available. Please try again.";
    return;
  }

  loading.value = true;
  try {
    const response = await axios.get(
      `${api_base_url}/api/paypal/resume/${token}/`,
      { withCredentials: true }
    );

    if (response.data.approval_url && response.data.resume_token) {
      approvalUrl.value = response.data.approval_url;
      window.location.href = approvalUrl.value; // auto-redirect
    } else {
      errorMessage.value = "Invalid checkout data. Please try again.";
    }
  } catch (error) {
    if (error.response && error.response.status === 410) {
      errorMessage.value = "Checkout expired or already completed.";
    } else {
      errorMessage.value = "Something went wrong. Try again later.";
    }
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <div class="min-h-screen flex items-center justify-center bg-theme-bg2 p-4">
    <div class="w-full max-w-md bg-theme-card p-6 rounded-lg shadow-md text-center">
      <h2 class="text-2xl font-semibold mb-4">Resume Checkout</h2>

      <button
        @click="resumeCheckout(checkoutToken)"
        :disabled="loading"
        class="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 disabled:opacity-50 disabled:cursor-not-allowed transition"
      >
        <span v-if="loading" class="animate-pulse">Processing...</span>
        <span v-else>Resume Checkout</span>
      </button>

      <p v-if="approvalUrl" class="mt-4 text-green-600">
        Redirecting... or click
        <a
          :href="approvalUrl"
          target="_blank"
          class="underline font-medium hover:text-blue-600"
        >
          here
        </a>.
      </p>

      <div v-if="errorMessage" class="mt-4">
        <p class="text-red-500 mb-2">{{ errorMessage }}</p>
        <button
          @click="resumeCheckout(checkoutToken)"
          class="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 transition"
        >
          Retry Checkout
        </button>
      </div>
    </div>
  </div>
</template>
